export interface IWebsiteBuilderItem {
    name: string;
    navName: string;
    navLink: string;
    isOpened: boolean;
    isPresent: boolean;
    isDisable: boolean;
    priority: number;
    value: any;
}

export class WebsiteBuilderItemBase implements IWebsiteBuilderItem {
    name: string;
    navName: string;
    navLink: string;
    isOpened: boolean = false;
    isPresent: boolean = false;
    isDisable: boolean;
    priority: number = 99;
    isShowInMenu: boolean = true;
    isHomePagePart: boolean = false;

    constructor(name: string = '', navName: string = '', navLink: string = '', isOpened: boolean = false, isPresent: boolean = false) {
        this.name = name || this.name;
        this.navName = navName || this.navName;
        this.navLink = navLink || this.navLink;
        this.isOpened = isOpened || this.isOpened;
        this.isPresent = isPresent || this.isPresent;
    }

    set value(item: any) {
        if (item.hasOwnProperty('status')) {
            this.isPresent = item.status;
        }
        this.priority = item.priority;
    }

    get value(): any {
        return {
            status: this.isPresent,
            priority: this.priority,
        };
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/items/website-builder-item-base.ts